import { render } from "./SalesRecordList.vue?vue&type=template&id=2cd6fade&scoped=true"
import script from "./SalesRecordList.vue?vue&type=script&lang=js"
export * from "./SalesRecordList.vue?vue&type=script&lang=js"

import "./SalesRecordList.vue?vue&type=style&index=0&id=2cd6fade&scoped=true&lang=css"
import "./SalesRecordList.vue?vue&type=style&index=1&id=2cd6fade&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd6fade"]])

export default __exports__